/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMXWidgetUrl_bankIntegrations_BankIntegrations = { readonly __typename: 'BankIntegrations', readonly widgetUrl: string };

export type GetMXWidgetUrl_Query = { readonly __typename: 'Query', readonly bankIntegrations: GetMXWidgetUrl_bankIntegrations_BankIntegrations };


export type GetMXWidgetUrlVariables = _Types.Exact<{
  mode: _Types.Scalars['String']['input'];
  companyId: _Types.Scalars['String']['input'];
  isMobile: _Types.Scalars['Boolean']['input'];
}>;


export type GetMXWidgetUrl = GetMXWidgetUrl_Query;


export const GetMXWidgetUrlDocument = gql`
    query GetMXWidgetUrl($mode: String!, $companyId: String!, $isMobile: Boolean!) {
  bankIntegrations(divvyUuid: $companyId, mode: $mode, isMobile: $isMobile) {
    widgetUrl
  }
}
    `;

/**
 * __useGetMXWidgetUrl__
 *
 * To run a query within a React component, call `useGetMXWidgetUrl` and pass it any options that fit your needs.
 * When your component renders, `useGetMXWidgetUrl` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMXWidgetUrl({
 *   variables: {
 *      mode: // value for 'mode'
 *      companyId: // value for 'companyId'
 *      isMobile: // value for 'isMobile'
 *   },
 * });
 */
export function useGetMXWidgetUrl(baseOptions: Apollo.QueryHookOptions<GetMXWidgetUrl, GetMXWidgetUrlVariables> & ({ variables: GetMXWidgetUrlVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMXWidgetUrl, GetMXWidgetUrlVariables>(GetMXWidgetUrlDocument, options);
      }
export function useGetMXWidgetUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMXWidgetUrl, GetMXWidgetUrlVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMXWidgetUrl, GetMXWidgetUrlVariables>(GetMXWidgetUrlDocument, options);
        }
export function useGetMXWidgetUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMXWidgetUrl, GetMXWidgetUrlVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMXWidgetUrl, GetMXWidgetUrlVariables>(GetMXWidgetUrlDocument, options);
        }
export type GetMXWidgetUrlHookResult = ReturnType<typeof useGetMXWidgetUrl>;
export type GetMXWidgetUrlLazyQueryHookResult = ReturnType<typeof useGetMXWidgetUrlLazyQuery>;
export type GetMXWidgetUrlSuspenseQueryHookResult = ReturnType<typeof useGetMXWidgetUrlSuspenseQuery>;
export type GetMXWidgetUrlQueryResult = Apollo.QueryResult<GetMXWidgetUrl, GetMXWidgetUrlVariables>;